/* Copyright (c) 2020-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Row } from "react-awesome-styled-grid";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { FlexContainer, theme } from "@nordcloud/gnui";
import { Logo, User } from "./components";
import { CustomerSwitcher } from "./components/SwitchCustomer/CustomerSwitcher";

const StyledLink = styled(Link)`
  display: flex;
  height: 100%;
  align-items: center;
  padding-left: ${theme.spacing.spacing02};
`;

const HeaderInner = styled.div`
  width: 100%;
  max-width: none;
  box-sizing: border-box;
  padding-top: ${theme.spacing.spacing02};
  padding-bottom: ${theme.spacing.spacing02};
  padding-right: ${theme.spacing.spacing03};
  padding-left: calc(
    var(--sidebar-content-offset) + ${theme.spacing.spacing04}
  );
`;

export function Header() {
  return (
    <HeaderInner>
      <Row justify="space-between">
        <span>
          <StyledLink to="/">
            <Logo />
          </StyledLink>
        </span>
        <FlexContainer>
          <CustomerSwitcher />
          <User />
        </FlexContainer>
      </Row>
    </HeaderInner>
  );
}
